import {
    FETCH_COMPLETED,
    ERROR ,
    DELETE_COMPLETED,
    PUSH_COMPLETED,
    SET_CURRENT_TYPE,
    SET_HISTORY,
    SET_CURRENT_ITEM,
    UPDATE_COMPLETED,
    SET_SHOW_EDIT_RECEIVER,
    SUB_ERROR,
    RECEIVER_CLEAR,
    UPDATE_FIELDS
} from "./ReceiverStates"

export default (state, action) => {
    const newState={
        ...state,
    }
    try{
      switch (action.type) {
          case DELETE_COMPLETED:
          case UPDATE_COMPLETED:
          case PUSH_COMPLETED:
            newState.completed = 'COMPLETED'
            return newState
        case FETCH_COMPLETED:

       //  //console.log(action.options)
          if(action.payload
             &&action.payload.data.receivers
           //  && action.payload.data.receivers.length >=0
             ){

                newState.receivers = action.payload.data.receivers
                newState.totalItemsInPage = action.payload.data.receivers.length
                newState.totalItems = parseInt(action.payload.data.quantityItems)
                newState.totalPages = Math.ceil(newState.totalItems/action.options.maxPerPage)
          }else throw {message:'receivers not present in response'}
          return newState
       return newState
           case SET_CURRENT_TYPE:
           if(action.payload.currentType)newState.currentType = action.payload.currentType
           return newState
        case SET_CURRENT_ITEM:
          //  //console.table(newState)
           if(action.payload.currentItemId){
                newState.currentItemId = action.payload.currentItemId
                newState.currentItem = newState.receivers.receivers.filter(item=>item.id===action.payload.currentItemId)[0]
           }
           return newState
       case SET_HISTORY:
           if(action.payload.history)newState.history = action.payload.history
           return newState
        case SET_SHOW_EDIT_RECEIVER:
          if(action.payload.showEditReceiver)newState.showEditReceiver = action.payload.showEditReceiver
          return newState
        case SUB_ERROR:
      // console.log('suberror',action.payload)
           if(typeof(action.payload)==='object'){
                if(action.payload.response&&action.payload.response.data&&action.payload.response.data.msg){
                    newState.subError = action.payload.response.data.msg
                }else if(action.payload.errorMsg){
                      newState.subError = action.payload.errorMsg
                  }else{
                    newState.subError = JSON.stringify(action.payload)
                  }
           }
          else newState.subError = action.payload
          return newState

        case RECEIVER_CLEAR:
            delete newState.completed
            delete newState.subError
            delete newState.error
            return newState
        case UPDATE_FIELDS:
            const ns = { ...newState, ...action.payload}
            return ns
        case ERROR:
         // //console.log('ERROR Receiver reducer',action.payload)
          if(action.payload.response&&action.payload.response.data&&action.payload.response.data.msg){
            newState.error = action.payload.response.data.msg
          }
          else newState.error = typeof(action.payload)==='string'? action.payload:JSON.stringify(action.payload)
          return newState
      default:
          return newState
      }
    }catch(error){
        newState.error = error
        newState.error.action_type= action.type
        newState.error.payload= action.payload
        //console.error(newState.error)
        return newState
    }
}
